import { routes } from '@/app/routing/router'
import { ShopPageView } from './view'

const currentRoute = routes.shop

const shopPageRoute = {
  route: currentRoute,
  view: ShopPageView,
}

export { currentRoute, shopPageRoute }
